// export const BASE_URL = 'http://localhost:3001/graphql';
export const BASE_URL = 'https://quiz-center-api.fly.dev/graphql';

export const QuizIndex = 'quizzes/index';

export const REMOVE_QUESTION_FROM_QUIZ = 'REMOVE_QUESTION_FROM_QUIZ';

export const LOGIN = 'login';

export const LOGOUT = 'logout';

export const SIGNUP = 'sign_up';

export const ANSWERED_QUESTION_CREATE = 'answered_questions/create';

export const ANSWERED_QUESTION_UPDATE = 'answered_questions/update';

export const NOTIFICATIONS = 'notifications';

export const RESULT = 'quizzes/result';

export const ADD_QUESTION = 'quizzes/question';

export const ADD_ANSWERED_QUESTION = 'quizzes/answeredQuestion';

export const RESET_QUESTION_AND_ANSWERED_QUESTION = 'quizzes/questions/answeredQuestions';

export const ADD_QUESTIONID = 'quizzes/selectedQuestionId';
